import {useActiveData} from 'coreHooks';
import {EEventType, IEventData} from 'coreClasses/events/IEvents';
import ProductModel from 'coreClasses/product/ProductModel';

const useHandleActiveDataEvents = () => {
	const activeData = useActiveData();

	const handleProductDetailView = (eventData: IEventData) => {
		const product: ProductModel = eventData.productData.product;

		activeData.sendViewProduct(
			{id: product.getCategoryId()},
			{id: product.getProductId()},
			'detail'
		);
	};

	const handleProductListLoad = (eventData: IEventData) => {
		const hits = eventData.productsData.map(({product})=> {
			return {
				productId: product.getProductId()
			};
		});

		if (eventData.sourceSpecification) {
			activeData.sendViewCategory(eventData.searchParams, {id: eventData.sourceSpecification}, {hits});
		} else {
			activeData.sendViewSearch(eventData.searchParams, {hits});
		}
	};

	return {
		update(eventType: EEventType, eventData: IEventData): void {
			switch (eventType) {
				case EEventType.PRODUCT_DETAIL_VIEW:
					handleProductDetailView(eventData);

					break;
				case EEventType.PRODUCT_LIST_LOAD:

					handleProductListLoad(eventData);

					break;
				default:
					break;
			};
		}
	};
};

export default useHandleActiveDataEvents;
